import { render, staticRenderFns } from "./StatsAppointments.vue?vue&type=template&id=80ab0d82"
import script from "./StatsAppointments.vue?vue&type=script&lang=ts"
export * from "./StatsAppointments.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports